import { Icon } from '@ur-solutions/react-components'
import {
  RoutePlanInstructionActionValue,
  RoutePlanInstructionDirectionValue,
  RoutePlanInstructionIcon,
} from '@/modules/routePlanner/consts'
import type { RoutePlanInstructionNode } from '@/modules/routePlanner/types.graphql'

export const RouteInstructionIcon: React.FC<{
  routeInstruction: RoutePlanInstructionNode
}> = ({ routeInstruction }) => {
  const getIconKey = (instruction: RoutePlanInstructionNode) => {
    if (instruction.action === RoutePlanInstructionActionValue.TURN) {
      //  TODO: Adjust this for turn severity etc.
      return instruction.direction === RoutePlanInstructionDirectionValue.LEFT
        ? 'turnLeft'
        : 'turnRight'
    }
    return instruction.action
  }
  const icon = RoutePlanInstructionIcon[getIconKey(routeInstruction)] ?? 'car'

  return <Icon icon={icon} />
}
